import { Box, useTheme } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import LandingAnimation from "../../../Helpers/LandingAnimation";
import { ColorScheme } from "../../../Themes/ColorScheme";
import BigButton from "../../Common/BigButton";
import { ModifyDialog } from "./EditDialog";

function SelectionActionBar({
    selectedUsers,
    clearSelectedUsers,
    handleRefresh,
    reservable,
    highlightColor,
}) {
    const theme = useTheme();

    const { t } = useTranslation();

    const [openDialog, setDialogOpen] = useState(false);

    const handleDialog = (open) => {
        setDialogOpen(open);
    }

    const handleDialogOpen = () => {
        setDialogOpen(true);
    }

    return (
        <Box
            role="region"
            aria-label="Valintojen työkalupalkki"
            sx={{
                position: "sticky",
                bottom: -70,
                zIndex: (t) => t.zIndex.modal + 1,
                width: "80%",
                mx: "auto",
                maxWidth: "500px",
            }}
        >
            {selectedUsers.length > 0 && (
                <LandingAnimation>
                    <Box sx={{
                        width: "100%",
                        padding: "20px",
                        backgroundColor: ColorScheme.secondary,
                        borderRadius: "20px",
                        display: "flex",
                        boxShadow: "0px 0px 50px 20px rgba(0, 0, 0, 0.2)",
                    }}>
                        <BigButton
                            width={"48%"}
                            text={t("key_management.remove_selected_users")}
                            action={clearSelectedUsers}
                            backgroundColor={ColorScheme.buttonSecondary}
                            borderColor={ColorScheme.buttonPrimary}
                            textColor={ColorScheme.buttonSecondaryText}
                        />
                        <div style={{flex: 1}}></div>
                        <BigButton
                            width={"48%"}
                            text={t("key_management.modify_selected_users") + " (" + selectedUsers.length + ")"}
                            backgroundColor={ColorScheme.buttonPrimary}
                            borderColor={ColorScheme.buttonPrimary}
                            textColor={ColorScheme.buttonPrimaryText}
                            action={handleDialogOpen}
                        />
                    </Box>
                </LandingAnimation>
            )}
            <ModifyDialog
                handleRefresh={handleRefresh}
                reservable={reservable}
                dialogOpen={openDialog}
                closeDialog={handleDialog}
                users={selectedUsers}
            />
        </Box>
    );
}

export default SelectionActionBar;